import React, { useEffect, useState, useRef } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import { resourcesReports, resourcesUnits } from "../../../helpers/backend_helper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Card, CardBody, CardHeader, Container, Row, Spinner } from "reactstrap";
import { getStorageUser } from "../../../helpers/api_helper";
import PeriodFilterHelper from "../../../helpers/PeriodFilterHelper";
import ButtonHelper from "../../../helpers/ButtonHelper";
import Select from "react-select";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import dayjs from "dayjs";
import PreviewPDF from "../../../helpers/previewPDF";

const PasajePorUnidadReport = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth() + 1 < 10 ? "0" : ""
    }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;
  const authUser = getStorageUser();
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "number",
    order: "asc",
    companySession: authUser.company_id,
    initDate: dateNow,
    unit_id: null,
  });
  const [salidas, setSalidas] = useState([]);
  const [totales, setTotales] = useState({});
  const [pending, setPending] = useState(false);
  const [unidad, setUnidad] = useState(null);
  const [modal, setModal] = useState(false);
  const [selects, setSelects] = useState({ units: [] });
  const [precioPasaje, setPrecioPasaje] = useState(0);

  useEffect(() => {
    if (!filters.initDate || !filters.unit_id) return;
    let params = { params: filters };
    setPending(true);
    resourcesReports("show", params, "pasajeUnidadReport").then((response) => {
      setSalidas(response.salidas);
      setTotales(response.totales);
      setUnidad(response.unit);
      setPrecioPasaje(response.costo_pasaje)

      setPending(false);
    });
  }, [filters]);
  const eleRef = useRef();

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesReports("show", config, "pasajeUnidadReport").then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte de Pasajes.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const units = await resourcesUnits("get", params);
      setSelects({
        ...selects,
        units: units.data,
      });
    };
    getSelects();
  }, []);

  const columns = Columns({ filters });
  document.title = "Pasaje por unidad|Reportes";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <Card>
              <CardHeader>
                <Row>
                  <Breadcrumb breadcrumbItem="Pasaje por Unidad" title="Reportes" />
                  <ButtonHelper
                    addButon={false}
                    reportButons={true}
                    actionReportButon={getReports}
                    pdfButton={true}
                  />
                  <div className="col-sm-2">
                    <label className="form-label">Fecha Inicial:</label>
                    <input className="form-control" placeholder='Fecha' name="time" type="date" onChange={e => setFilters({ ...filters, initDate: e.target.value })} value={filters.initDate} />
                  </div>
                  <div className="col-sm-2">
                    <label className="form-label">Unidad:</label>
                    <Select
                      style={{ padding: "01.25rem 0.5rem" }}
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={true}
                      isSearchable={false}
                      name="week"
                      value={selects.units.find(e => filters.unit_id == e.id) ?? null}
                      options={selects.units}
                      getOptionLabel={(option) => `${option.number}`}
                      getOptionValue={(option) => `${option.id}`}
                      onChange={(e) => [
                        setFilters({ ...filters, unit_id: e ? e.id : null }),
                      ]}
                    />
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {pending ? <Spinner color="primary" /> :
                  <div>
                    <h5 className="text-center mb-3">
                      Reporte de Pasajes de la Unidad {unidad ? unidad.number : ''}<br />
                      <small>Fecha {dayjs(filters.initDate).format('DD/MM/YY')}</small>
                    </h5>
                    <table className="table table-striped table-sm">
                      <thead>
                        <tr className="text-center">
                          <th>Salida</th>
                          <th>Fecha / Hora</th>
                          <th>Pasaje<br />Sensores</th>
                          <th>Tickets<br />Adulto</th>
                          <th>Tickets<br /> Menores</th>
                          <th>Tickets<br /> Totales</th>
                          <th>Diferencia</th>
                          <th>Importe<br />Pasaje</th>
                          <th>Importe<br />Tickets</th>
                        </tr>
                      </thead>
                      <tbody>
                        {salidas.map((salida, index) => (
                          <tr key={index} className="text-center">
                            <td>{salida.salida_no}</td>
                            <td>{salida.date}</td>
                            <td>{salida.pasajeros}</td>
                            <td>{salida.tickets}</td>
                            <td>{salida.tickets_menor}</td>
                            <td>{salida.tickets_total}</td>
                            <td>{salida.diferencia}</td>
                            <td>${salida.importe_pasaje}</td>
                            <td>${salida.importe_tickets}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr className="text-center fw-bold">
                          <td colSpan="2" className="text-end">Totales</td>
                          <td>{totales.pasajeros}</td>
                          <td>{totales.tickets}</td>
                          <td>{totales.tickets_menor}</td>
                          <td>{totales.tickets_total}</td>
                          <td>{totales.diferencia}</td>
                          <td>${totales.importe_pasaje}</td>
                          <td>${totales.importe_tickets}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                }
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
      {modal.show && (
          <PreviewPDF modalPdf={modal} setModalPdf={setModal} />
      )}
    </React.Fragment>
  );
};

export default PasajePorUnidadReport;
